// import { createStore, createLogger } from 'vuex'
import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { companiesAccountSetting } from './stores/companies/accountSetting'
import { companiesAnalysisInsight } from './stores/companies/analysis/insight'
import {companiesAnalysisRanking} from './stores/companies/analysis/ranking'
import { companiesAnalysisReviews } from './stores/companies/analysis/reviews'
import { companiesAnalysisVisitors } from './stores/companies/analysis/visitors'
import { companiesAnalysisKeywords } from './stores/companies/analysis/keywords'
import { companiesAnalysisSurveys } from './stores/companies/analysis/surveys'
import { companiesArticles } from './stores/companies/articles'
import { companiesAvailablePlan } from './stores/companies/availablePlan'
import { companiesBrand } from './stores/companies/brand'
import { companiesBrands } from './stores/companies/brands'
import { companiesBrandStores } from './stores/companies/brand/stores'
import { companiesBulkUpdates } from './stores/companies/bulkUpdates'
import { companiesBulkUpdateWithGmbs } from './stores/companies/bulkUpdateWithGmbs'
import { companiesBulkUpdateStoreOptions } from './stores/companies/bulkUpdateStoreOptions'
import { companiesCompetitorBrand } from './stores/companies/competitorBrand'
import { companiesCompetitorBrands } from './stores/companies/competitorBrands'
import { companiesCompetitorsReviews } from './stores/companies/competitors/reviews'
import { companiesCompetitorsPhotos } from './stores/companies/competitors/photos'
import { companiesBusinessTypes } from './stores/companies/businessTypes'
import { companiesCompany } from './stores/companies/company'
import { companiesCompanyAddress } from './stores/companies/companyAddress'
import { companiesCreditCards } from './stores/companies/creditCards'
import { companiesDashboardAnalysisReviewSummaries } from './stores/companies/dashboard/analysis/reviewSummaries'
import { companiesDashboardNotifications } from './stores/companies/dashboard/notifications'
import { companiesDashboardReviews } from './stores/companies/dashboard/reviews'
import { companiesFranchisee } from './stores/companies/franchisee'
import { companiesFranchisees } from './stores/companies/franchisees'
import { companiesGmbAccount } from './stores/companies/gmb/account'
import { companiesGmbAccounts } from './stores/companies/gmb/accounts'
import { companiesGmbCategories } from './stores/companies/gmb/categories'
import { companiesGmbStores } from './stores/companies/gmb/stores'
import { companiesGoogleOauth } from './stores/companies/googleOauth'
import { companiesInvitations } from './stores/companies/invitations'
import { companiesInitialSetupGuides } from './stores/companies/initialSetupGuides'
import { companiesSkippedTodos } from './stores/companies/skippedTodos'
import { companiesNotification } from './stores/companies/notification'
import { companiesNotifications } from './stores/companies/notifications'
import { companiesPaymentHistories } from './stores/companies/paymentHistories'
import { companiesPhotos } from './stores/companies/photos'
import { companiesRegistrationsBrand } from './stores/companies/registrations/brand'
import { companiesRegistrationsBusinessTypes } from './stores/companies/registrations/businessTypes'
import { companiesRegistrationsInfo } from './stores/companies/registrations/info'
import { companiesRegistrationsProgresses } from './stores/companies/registrations/progresses'
import { companiesRegistrationsStore } from './stores/companies/registrations/store'
import { companiesRegistrationsStoreSites } from './stores/companies/registrations/storeSites'
import { companiesReplyTemplates } from './stores/companies/replyTemplates'
import { companiesReplyTemplate } from './stores/companies/replyTemplate'
import { companiesReviews } from './stores/companies/reviews'
import { companiesSearchAttributes } from './stores/companies/searchAttributes'
import { companiesServicePatterns } from './stores/companies/servicePatterns'
import { companiesStockRequests } from './stores/companies/stockRequests'
import { companiesSites } from './stores/companies/sites'
import { companiesStores } from './stores/companies/stores'
import { companiesLocationStore } from './stores/companies/location/store'
import { companiesLocationStores } from './stores/companies/location/stores'
import { companiesStoreExternalAccount } from './stores/companies/store/externalAccount'
import { companiesStoreExternalAccounts } from './stores/companies/store/externalAccounts'
import { companiesStoreGmb } from './stores/companies/store/gmb'
import { companiesStoreGmbInfos } from './stores/companies/store/gmbInfos'
import { companiesStoreGmbLocations } from './stores/companies/store/gmbLocations'
import { companiesStoreOption } from './stores/companies/store/option'
import { companiesStoreSocial } from './stores/companies/store/social'
import { companiesStoreMediaLibrary } from './stores/companies/store/mediaLibrary'
import { companiesStoreMediaLibraries } from './stores/companies/store/mediaLibraries'
import { companiesStoreMediaLibraryStore } from './stores/companies/store/mediaLibraryStore'
import { companiesStorePaymentMethods } from './stores/companies/store/paymentMethods'
import { companiesStorePosts } from './stores/companies/store/posts'
import { companiesStoreSnsPosts } from './stores/companies/store/snsPosts'
import { companiesStoreBusinessHours } from './stores/companies/store/businessHours'
import { companiesStoreBusinessHoursCrawlers } from './stores/companies/store/businessHoursCrawlers'
import { companiesStoreCompetitor } from './stores/companies/store/competitor'
import { companiesStoreCompetitors } from './stores/companies/store/competitors'
import { companiesStoreServicePatterns } from './stores/companies/store/servicePatterns'
import { companiesSurveyTemplates } from './stores/companies/surveyTemplates'
import { companiesTagGroups } from './stores/companies/tagGroups'
import { companiesUpgradablePlans } from './stores/companies/upgradablePlans'
import { companiesUsers } from './stores/companies/users'
import { companiesVisitorStore } from './stores/companies/visitor/store'
import { companiesVisitorStores } from './stores/companies/visitor/stores'
import { companiesUserCompany } from './stores/companies/userCompany'
import { companiesAccessibleApi } from './stores/companies/accessibleApi'
import { companiesUserActivity } from './stores/companies/userActivity'
import { companiesArea } from './stores/companies/area'
import { companiesAreas } from './stores/companies/areas'
import { companiesTestimonials } from './stores/companies/testimonials'
import { companiesTestimonialsFiles } from './stores/companies/testimonials/files'
import { companiesAnalysisSettingsKeywords } from './stores/companies/analysis/settings/keywords'
import { companiesAnalysisSettingsIgnores } from './stores/companies/analysis/settings/ignores'
import { companiesMailReceivable } from './stores/companies/mailReceivable'
import { companiesAvailableSites } from './stores/companies/availableSites'
import { companiesGmbLocationSyncLogs } from './stores/companies/gmbLocationSyncLogs'
import { companiesExportResults } from './stores/companies/export/results'
import { companiesChangeablePlans } from './stores/companies/changeablePlans'
import { companiesStoreGmbCategories } from './stores/companies/store/gmb/categories'
import { companiesStoreGmbCategoriesWithServicePatterns } from './stores/companies/store/gmb/categoriesWithServicePatterns'
import { companiesStoreGmbMetadata } from './stores/companies/store/gmb/metadata'
import { companiesGmbSearchAttributes } from './stores/companies/gmb/searchAttributes'
import {companiesGmbSearchStores} from './stores/companies/gmb/searchStores'
import { companiesMediaImage } from './stores/companies/mediaImage'
import { companiesMediaLibrary } from './stores/companies/mediaLibrary'
import { companiesMediaLibraryStores } from './stores/companies/mediaLibraryStores'
import { plans } from './stores/plans'
import { sites } from './stores/sites'
import { filters } from './stores/global/filters'
import { flash } from './stores/global/flash'
import { hoverMenu } from './stores/global/hoverMenu'
import { menu } from './stores/global/menu'
import { layout } from './stores/global/layout'
import { companiesOriginalTagGroup } from './stores/companies/originalTagGroup'
import { companiesOriginalTagGroupsTag } from './stores/companies/originalTagGroups/tag'
import { companiesOriginalTagGroups } from './stores/companies/originalTagGroups'
import { companiesAnalysisAxes } from './stores/companies/analysis/axes'
import { companiesSearchTagGroups } from './stores/companies/searchTagGroups'
import { companiesFoodMenus } from './stores/companies/foodMenus'
import { companiesFoodMenu } from './stores/companies/foodMenu'
import { companiesStoreFoodMenu } from './stores/companies/store/foodMenu'
import { companiesStoreProducts } from './stores/companies/store/products'
import { companiesMediaLibraries } from './stores/companies/media/libraries'
import { companiesMediaImages } from './stores/companies/mediaImages'
import { companiesAnalysisQscas } from './stores/companies/analysis/qscas'
import { companiesAnalysisQsca } from './stores/companies/analysis/qsca'
import { companiesProductCategories } from './stores/companies/product/categories'
import { companiesProductCategory } from './stores/companies/product/category'
import { companiesProductBulkOperations } from './stores/companies/product/bulkOperations'
import { companiesProduct } from './stores/companies/product'
import { companiesProducts } from './stores/companies/products'
import { companiesStoreGmbAttributes } from './stores/companies/store/gmb/attributes'
import { companiesStoreGmbFoodorderings } from './stores/companies/store/gmb/foodorderings'
import { companiesStoreGmbOpenInfo } from './stores/companies/store/gmb/openInfo'
import { companiesCustomSurvey } from './stores/companies/customSurvey'
import { companiesCustomSurveys } from './stores/companies/customSurveys'
import { companiesCustomSurveySurveys } from './stores/companies/customSurveys/surveys'
import { companiesCustomSurveyBrands } from './stores/companies/customSurveys/brands'
import { companiesPublishingCustomSurveyBrands } from './stores/companies/customSurveys/customSurveyBrands.js'
import { companiesCustomSurveyAnswers } from './stores/companies/customSurveys/answers'
import { companiesCustomSurveyAnswerFiles } from './stores/companies/customSurveys/answerFiles'
import { companiesStoreOcShufoo } from './stores/companies/store/oc/shufoo'
import { companiesStoreOcShufooAttributes } from './stores/companies/store/oc/shufoo/attributes'
import { companiesStoreOcMapionBiz } from './stores/companies/store/oc/mapionBiz'
import { companiesStoreOcMapionBizAttributes } from './stores/companies/store/oc/mapionBiz/attributes'
import { companiesParameters } from './stores/companies/parameters'
import { companiesParameter } from './stores/companies/parameter'
import { companiesPostsManagementsApprovalFlows } from './stores/companies/posts/managements/approvalFlows'
import { companiesSearchPatterns } from './stores/companies/searchPatterns'
import { companiesSearchPatternsNotificationConfigs } from './stores/companies/searchPatterns/notificationConfigs'
import { companiesServicePattern } from './stores/companies/servicePattern'
import { gmbCategory } from './stores/companies/gmbCategory'
import { companiesMapionBizSearchGroups } from './stores/companies/mapionBiz/searchGroups'
import { companiesMapionBizSearchGroupsOrders } from './stores/companies/mapionBiz/searchGroups/orders'
import { companiesMapionBizSearchGroupsConditionStores } from './stores/companies/mapionBiz/searchGroups/conditionStores'
import { companiesStoreOcMapionBizSearchGroups } from './stores/companies/store/oc/mapionBiz/searchGroups'
import { companiesMapionBizBannersTemplates } from './stores/companies/mapionBiz/banners/templates'
import { companiesMapionBizBannersTemplatesCsvDownloads } from './stores/companies/mapionBiz/banners/templates/csv_downloads'
import { companiesMapionBizBannersCsvImportResultCsvDownloads } from './stores/companies/mapionBiz/banners/csv_import_result/csv_downloads'
import { companiesMapionBizBannersTemplatesCsvImports } from './stores/companies/mapionBiz/banners/templates/csv_imports'
import { companiesStoreTabelogAttributes } from './stores/companies/store/tabelog/attributes'
import { companiesSnsCategory } from './stores/companies/sns/category'
import { companiesSnsCategories } from './stores/companies/sns/categories'
import { companiesSnsApprovalFlows } from './stores/companies/sns/approvalFlows'
import { companiesSnsFacebookPages } from './stores/companies/sns/facebook/pages'
import { companiesSnsInstagramBusinessAccounts } from './stores/companies/sns/instagram/business_accounts'
import { companiesSnsTwitterUserProfiles } from './stores/companies/sns/twitter/user_profiles'
import { companiesSnsInstagramHashtag } from './stores/companies/sns/instagram/hashtag'
import { companiesPostsCategories } from './stores/companies/posts/categories'

const state = {
  locale: ''
}
const mutations = {
  setLocale (state, val) {
    state.locale = val
  },
}

const actions = {
  setLocale({ commit }, payload) {
    commit('setLocale', payload.locale)
  }
}

const plugins = [
  createPersistedState({
    storage: window.localStorage,
    key: 'kComBizSpa',
    paths: [
      'locale',
    ]
  })
]

export const store = createStore({
  state,
  mutations,
  actions,
  modules: {
    companiesAnalysisAxes,
    companiesAnalysisSurveys,
    companiesAccountSetting,
    companiesAnalysisInsight,
    companiesAnalysisRanking,
    companiesAnalysisQscas,
    companiesAnalysisQsca,
    companiesAnalysisReviews,
    companiesAnalysisVisitors,
    companiesAnalysisKeywords,
    companiesArticles,
    companiesAvailablePlan,
    companiesBrand,
    companiesBrands,
    companiesBrandStores,
    companiesBulkUpdates,
    companiesBulkUpdateWithGmbs,
    companiesBulkUpdateStoreOptions,
    companiesCompetitorBrand,
    companiesCompetitorBrands,
    companiesCompetitorsReviews,
    companiesCompetitorsPhotos,
    companiesCustomSurvey,
    companiesCustomSurveys,
    companiesCustomSurveySurveys,
    companiesCustomSurveyBrands,
    companiesPublishingCustomSurveyBrands,
    companiesCustomSurveyAnswers,
    companiesCustomSurveyAnswerFiles,
    companiesBusinessTypes,
    companiesCompany,
    companiesCompanyAddress,
    companiesCreditCards,
    companiesDashboardAnalysisReviewSummaries,
    companiesDashboardNotifications,
    companiesDashboardReviews,
    companiesFranchisee,
    companiesFranchisees,
    companiesGmbAccount,
    companiesGmbAccounts,
    companiesGmbCategories,
    companiesGmbStores,
    companiesGoogleOauth,
    companiesInvitations,
    companiesInitialSetupGuides,
    companiesSkippedTodos,
    companiesNotification,
    companiesNotifications,
    companiesOriginalTagGroup,
    companiesPaymentHistories,
    companiesPhotos,
    companiesRegistrationsBrand,
    companiesRegistrationsBusinessTypes,
    companiesRegistrationsInfo,
    companiesRegistrationsProgresses,
    companiesRegistrationsStore,
    companiesRegistrationsStoreSites,
    companiesReplyTemplates,
    companiesReplyTemplate,
    companiesReviews,
    companiesSearchAttributes,
    companiesServicePatterns,
    companiesStockRequests,
    companiesSites,
    companiesStores,
    companiesLocationStore,
    companiesLocationStores,
    companiesStoreExternalAccount,
    companiesStoreExternalAccounts,
    companiesStoreGmb,
    companiesStoreGmbInfos,
    companiesStoreGmbLocations,
    companiesStoreGmbAttributes,
    companiesStoreGmbFoodorderings,
    companiesStoreOption,
    companiesStoreSocial,
    companiesStoreMediaLibrary,
    companiesStoreMediaLibraries,
    companiesStoreMediaLibraryStore,
    companiesStoreServicePatterns,
    companiesStoreGmbMetadata,
    companiesStorePaymentMethods,
    companiesStorePosts,
    companiesStoreSnsPosts,
    companiesStoreBusinessHours,
    companiesStoreBusinessHoursCrawlers,
    companiesStoreCompetitor,
    companiesStoreCompetitors,
    companiesSurveyTemplates,
    companiesUpgradablePlans,
    companiesUsers,
    companiesTagGroups,
    companiesOriginalTagGroupsTag,
    companiesOriginalTagGroups,
    companiesVisitorStore,
    companiesVisitorStores,
    companiesUserCompany,
    companiesAccessibleApi,
    companiesUserActivity,
    companiesArea,
    companiesAreas,
    companiesTestimonials,
    companiesTestimonialsFiles,
    companiesAnalysisSettingsKeywords,
    companiesAnalysisSettingsIgnores,
    companiesMailReceivable,
    companiesAvailableSites,
    companiesGmbLocationSyncLogs,
    companiesExportResults,
    companiesChangeablePlans,
    companiesStoreGmbOpenInfo,
    companiesStoreGmbCategories,
    companiesStoreGmbCategoriesWithServicePatterns,
    companiesGmbSearchAttributes,
    companiesGmbSearchStores,
    companiesSearchTagGroups,
    companiesServicePattern,
    companiesFoodMenus,
    companiesFoodMenu,
    companiesStoreFoodMenu,
    companiesStoreProducts,
    companiesMediaImage,
    companiesMediaImages,
    companiesMediaLibrary,
    companiesMediaLibraryStores,
    companiesMediaLibraries,
    companiesProductCategories,
    companiesProductCategory,
    companiesProduct,
    companiesProducts,
    companiesProductBulkOperations,
    companiesStoreOcShufoo,
    companiesStoreOcShufooAttributes,
    companiesStoreOcMapionBiz,
    companiesStoreOcMapionBizAttributes,
    companiesParameters,
    companiesParameter,
    companiesPostsManagementsApprovalFlows,
    companiesSearchPatterns,
    companiesSearchPatternsNotificationConfigs,
    companiesMapionBizSearchGroups,
    companiesMapionBizSearchGroupsOrders,
    companiesMapionBizSearchGroupsConditionStores,
    companiesStoreOcMapionBizSearchGroups,
    companiesMapionBizBannersTemplates,
    companiesMapionBizBannersTemplatesCsvDownloads,
    companiesMapionBizBannersCsvImportResultCsvDownloads,
    companiesMapionBizBannersTemplatesCsvImports,
    companiesStoreTabelogAttributes,
    companiesSnsCategory,
    companiesSnsCategories,
    companiesSnsApprovalFlows,
    companiesSnsFacebookPages,
    companiesSnsInstagramBusinessAccounts,
    companiesSnsTwitterUserProfiles,
    companiesSnsInstagramHashtag,
    companiesPostsCategories,
    plans,
    sites,
    filters,
    flash,
    gmbCategory,
    hoverMenu,
    menu,
    layout,
  },
  plugins,
  // debugしたい人のために残す
  // plugins: process.env.NODE_ENV === 'development' ? [...plugins, createLogger()] : plugins,
})
